// Utilities
// ---------------------------------------------
import { initComponents } from './../utils/initComponents'

// Components
// ---------------------------------------------
import TabView from './../components/TabView';
import Modal from './../components/Modal';
import Slideshow from './../components/Slideshow';
import ImageReveal from './../components/ImageReveal';
import GlobalNav from './../components/GlobalNav';
import Simplecast from './../components/Simplecast';
import StickyHeader from './../components/StickyHeader';
import CookiePolicy from './../components/CookiePolicy';

let APP = {}

// Helpers
// ---------------------------------------------
APP.helpers = {
    initComponents: $elem => initComponents($elem, APP)
}

// Page Components
// <elem data-js-component="<component name>">
// ---------------------------------------------
APP.components = {
    // x: (elem) => new x(elem, APP).init(),
    TabView: (elem) => new TabView(elem, APP).init(),
    Modal: (elem) => new Modal(elem, APP).init(),
    Slideshow: (elem) => new Slideshow(elem, APP).init(),
    ImageReveal: (elem) => new ImageReveal(elem, APP).init(),
    GlobalNav: (elem) => new GlobalNav(elem, APP).init(),
    Simplecast: (elem) => new Simplecast(elem, APP).init(),
    StickyHeader: (elem) => new StickyHeader(elem, APP).init(),
    CookiePolicy: (elem) => new CookiePolicy(elem, APP).init()
}

export default APP
